import {Injectable} from '@angular/core';

const wasm = import('../../../session-encryption/pkg');

@Injectable({providedIn: 'root'})
export class SessionEncryptionWrapper {
	async create_key_pair(): Promise<string> {
		const session_encryption = await wasm;
		return session_encryption.create_key_pair();
	}

	async encrypt(public_key: string, plain_text: string): Promise<string> {
		const session_encryption = await wasm;
		return session_encryption.encrypt(public_key, plain_text);
	}

	async decrypt(private_key: string, cipher_text: string): Promise<string> {
		const session_encryption = await wasm;
		return session_encryption.decrypt(private_key, cipher_text);
	}
}
